$(document).ready(function() {
    const selectors = {
        countdownWrapper: '.shippingCountdown',
        countdownText: '.shippingCountdownText'
    };

    var dayofweek = moment().isoWeekday();
    var hourofday = moment().hour();
    var minuteofhour = moment().minute();
    var timezone = moment.tz.guess();
    var daydescriptor, offsetHours;

    if (timezone == "America/New_York"){
        offsetHours = 10.5;
        if(dayofweek == 1 || dayofweek == 2 || dayofweek == 4 || dayofweek == 5) {
            if (hourofday < 10.5) {
                daydescriptor = "today";
            } else {
                daydescriptor = "tomorrow";
            }
        } else if (dayofweek == 3) {
            if (hourofday <= 10.5) {
                daydescriptor = "today";
            } else {
                daydescriptor = "tomorrow";
            }
        } else if (dayofweek == 6) {
            daydescriptor = "Monday";
        } else if (dayofweek == 7) {
            daydescriptor = "tomorrow";
        }
    } else if (timezone == "America/Chicago"){
        offsetHours = 9.5;
        if(dayofweek >= 1 && dayofweek <= 4) {
            if (hourofday < 9.5) {
                daydescriptor = "today";
            } else {
                daydescriptor = "tomorrow";
            }
        } else if (dayofweek == 5) {
            if (hourofday < 9.5) {
                daydescriptor = "today";
            } else {
                daydescriptor = "Monday";
            }
        } else if (dayofweek == 6) {
            daydescriptor = "Monday";
        } else if (dayofweek == 7) {
            daydescriptor = "tomorrow";
        }
    } else if (timezone == "America/Denver"){
        offsetHours = 8.5;
        if(dayofweek >= 1 && dayofweek <= 5) {
            if (hourofday < 8.5) {
                daydescriptor = "today";
            } else {
                daydescriptor = "tomorrow";
            }
        } else if (dayofweek == 6) {
            daydescriptor = "Monday";
        } else if (dayofweek == 7) {
            daydescriptor = "tomorrow";
        }
    } else if (timezone == "America/Los_Angeles") {
        offsetHours = 7.5;
        if(dayofweek >= 1 && dayofweek <= 5) {
            if (hourofday < 7.5) {
                daydescriptor = "today";
            } else {
                daydescriptor = "tomorrow";
            }
        } else if (dayofweek == 6) {
            daydescriptor = "Monday";
        } else if (dayofweek == 7) {
            daydescriptor = "tomorrow";
        }
    } else {
        offsetHours = 7.5;
        if(dayofweek >= 1 && dayofweek <= 4) {
            if (hourofday < 7.5) {
                daydescriptor = "today";
            } else {
                daydescriptor = "tomorrow";
            }
        } else if (dayofweek == 5) {
            if (hourofday < 7.5) {
                daydescriptor = "Monday";
            } else {
                daydescriptor = "Monday";
            }
        } else if (dayofweek == 6) {
            daydescriptor = "Monday";
        } else if (dayofweek == 7) {
            daydescriptor = "tomorrow";
        }
    }

    function updateCountdown() {
        if (moment().hour() < offsetHours) {
            $(selectors.countdownText).countdown(moment().startOf('date').add(offsetHours, 'h').toDate(), function(event) {
                if (event.offset.hours < 1) {
                    var $this = $(this).html(event.strftime('' + 'Order within <strong>%-M min</strong> ' + '<strong>%S sec</strong> ' + 'and it ships <strong>FREE ' + daydescriptor +'</strong>.'));
                } else {
                    var $this = $(this).html(event.strftime('' + 'Order within ' + '<strong>%-H hr</strong> ' + '<strong>%-M min</strong> ' + 'and it ships <strong>FREE ' + daydescriptor +'</strong>.'));
                }
            });
        } else {
            $(selectors.countdownText).countdown(moment().endOf('date').add(0, 'h').toDate(), function(event) {
                if (event.offset.hours < 1) {
                    var $this = $(this).html(event.strftime('' + '<span>Order within <strong>%-M min</strong> ' + '<strong>%S sec</strong> ' + 'and it ships <strong>FREE ' + daydescriptor +'</strong>.'));
                } else {
                    var $this = $(this).html(event.strftime('' + 'Order within ' + '<strong>%-H hr</strong> ' + '<strong>%-M min</strong> ' + 'and it ships <strong>FREE ' + daydescriptor +'</strong>.'));
                }
            });
        }
    }

    updateCountdown();

    let secondsLeft = 24 * 60 * 60; // 24 hours in seconds
    setInterval(function() {
        secondsLeft--;
        if (secondsLeft <= 0) {
            clearInterval(this);
        } else {
            updateCountdown();
        }
    }, 1000);
});
